import * as React from 'react';
import { MethodWrapperContainer } from '../MethodWrapper';
import sbpIcon from './assets/sbp.png';

interface IProps {
  id: string;
}

export const FastPaymentSystem = (props: IProps) => {
  const { id } = props;

  return (
    <MethodWrapperContainer id={id}>
      <img src={sbpIcon} width="60" />
    </MethodWrapperContainer>
  );
};
